// Bookmarklet "Importar CNPJ": o usuário arrasta o link para a barra de
// favoritos e clica nele na página do comprovante da Receita Federal.
//
// Ele tenta três saídas, nesta ordem, porque nenhuma funciona em todo cenário:
//   1. POST para /webhook/cnpj-import — única que funciona em aba que não foi
//      aberta pelo CRM (não depende de window.opener nem de clipboard);
//   2. postMessage para a janela que abriu a aba, quando existe;
//   3. cópia para a área de transferência, se o CSP da página bloquear o fetch.

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const buildReceitaBookmarklet = (token) => {
  if (!token || !BACKEND_URL) return "";

  const code = `(function(){
    var t=document.body.innerText;
    if(!t||t.indexOf("NÚMERO DE INSCRIÇÃO")===-1){alert("Abra o comprovante do CNPJ antes de clicar em Importar CNPJ.");return;}
    if(window.opener){try{window.opener.postMessage({type:"receita-cnpj-comprovante",text:t},"*");}catch(e){}}
    var copia=function(){
      try{navigator.clipboard.writeText(t).then(function(){alert("Comprovante copiado. Volte ao CRM e clique em Importar dados.");},function(){alert("Não foi possível enviar. Copie a página com Ctrl+A e Ctrl+C.");});}
      catch(e){alert("Não foi possível enviar. Copie a página com Ctrl+A e Ctrl+C.");}
    };
    try{
      fetch(${JSON.stringify(BACKEND_URL)}+"/webhook/cnpj-import",{
        method:"POST",credentials:"omit",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({token:${JSON.stringify(token)},text:t})
      }).then(function(r){
        if(r.ok){alert("Dados enviados. Volte para a janela do CRM.");}else if(r.status===401){alert("Sessão do bookmarklet expirada. Arraste o botão Importar CNPJ de novo para a barra de favoritos.");}else{copia();}
      },copia);
    }catch(e){copia();}
  })();`;

  return `javascript:${encodeURIComponent(code.replace(/\s*\n\s*/g, ""))}`;
};

export default buildReceitaBookmarklet;
